/* eslint-disable */
export default {
  participants: 'Participantes',
  host: '(Host)',
  removeParticipant: 'Eliminar participante',
  removeTitle: 'Eliminar participante',
  removeDescription: '¿Eliminar a{name}de esta conferencia?',
  confirmButtonText: 'Eliminar',
  cancelButtonText: 'Cancelar',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
